<script>
import { Bar, mixins } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { random } from '@/shared/utils'
import moment from 'moment'

export default {
  extends: Bar,
  props: ['height', 'options', 'chartData', 'userData', 'userId'],
  mixins: [mixins.reactiveProp],

  mounted () {
    var self = this

    // let d = this.chartData;
    // console.log(d)
    // console.log(this.userData)

    const chartColorScheme = [
      '#20c997',  // teal
      '#17a2b8',  // cyan
      '#6f42c1',  // purple
      '#ffc107',  // brand warning (yellow)
      '#c8ced3',  // gray 300
      '#63c2de',  // brand secondary (light blue)
      '#6610f2',  // indigo
      '#73818f',  // gray 600

      '#52E3B8',  // teal 15% lighter
      '#94EED3',  // teal 30% lighter
      '#158765',  // teal 15% darker

      '#36CEE6',  // cyan 15% lighter
      '#7ADFEE',  // cyan 30% lighter
      '#117A8B',  // cyan 10% darker

      '#9B7CD4',  // purple 15% lighter
      '#C7B6E7',  // purple 30% lighter

      '#FFD454',  // yellow, 15% lighter
      '#FFE7A1',  // yellow, 30% lighter

      '#FF9807',  // orange
      '#FFAD3A',  // orange 10% lighter
    ]

    let messageData = this.chartData.message_counts
    let mentionsData = this.chartData.mentions

    let xAxisLabels = []
    let epochPosMap = {}

    // first the message data
    let chartMessageData = {
      label: 'Messages Sent',
      data: []
    }
    Object.keys(messageData).forEach(function(uid) {
      Object.keys(messageData[uid]).forEach(function(epoch, index) {
        let row = messageData[uid][epoch]
        epochPosMap[epoch] = index
        xAxisLabels.push(moment.unix(epoch).format('MMM Do hA'))
        chartMessageData.data.push(row.channel + row.direct + row.mpim)
      })

    })

    // now the mentions data
    let chartMentionedData = {
      label: 'Mentioned by Another User',
      data: new Array(chartMessageData.data.length).fill(0)
    }
    let chartMentionerData = {
      label: 'Mentioned Another User',
      data: new Array(chartMessageData.data.length).fill(0)
    }

    for(const row of mentionsData) {
      let epochPos = epochPosMap[row.epoch]
      if(row.at_id == this.userId) {
        let curVal = chartMentionedData.data[epochPos]
        chartMentionedData.data.splice(epochPos, 1, curVal + row.mentions)
      } else if(row.sender_id == this.userId) {
        let curVal = chartMentionerData.data[epochPos]
        chartMentionerData.data.splice(epochPos, 1, curVal + row.mentions)
      } else {
        console.log('Another user data somehow got in here')
        continue
      }
    }

    // create chartJS dataset
    let chartDatasets = [chartMessageData, chartMentionedData, chartMentionerData]

    this.renderChart({
      labels: xAxisLabels,
      datasets: chartDatasets
    }, 
    // chart options
    {
      tooltips: {
        enabled: false,
        custom: CustomTooltips,
        displayColors: true,
        intersect: true,
        mode: 'index',
        position: 'nearest',
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
          }
        }
      },
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'bottom'
      },
      scales: {
        xAxes: [{
          stacked: true,
          gridLines: {
            drawOnChartArea: false
          },
          ticks: {
            autoSkip: true,
            maxTicksLimit: 24 // this will need to be dynamic based on time window
          }
          
        }],
        yAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: true
          }
        }]
      },

      plugins: {
        colorschemes: {
          scheme: chartColorScheme
        }
      }

    })
        
  }
}
</script>
